// dependencies
import React from "react";

import { Grid, GridCol } from "../../../../components/Grid";
import { Card } from "../../components/Card";
// components
import { Divider, Layout, Row } from "../../components/Layout";

// config
import Config from "../../Config";
import FactorsPolygon from "./Cards/FactorsPolygon";
// kpi cards
import OverallKPIs from "./Cards/KPIs/Overall";
import SatisfactionRange from "./Cards/KPIs/SatisfactionRange";
import Enps from "./Cards/KPIs/enpsKPI";
// row 2 cards
import OverallSatisfaction from "./Cards/OverallSatisfaction";
import Participation from "./Cards/Participation";
// row 3 cards
import TopCohorts from "./Cards/TopCohorts";
import EnpsOverallScatter from "./Cards/enpsOverallScatter";

const overviewConfig = Config.OVERVIEW;

const Overview = () => {
	return (
		<Layout title="Overview">
			<Row height={overviewConfig.ROW_HEIGHTS[0]}>
				<Grid gap={2} cols={4} padding={0}>
					<GridCol span={1}>
						<Card padX={16} height={overviewConfig.ROW_HEIGHTS[0]} testId="satisfaction-score-card">
							<OverallKPIs />
						</Card>
					</GridCol>
					<GridCol span={1}>
						<Card padX={16} height={overviewConfig.ROW_HEIGHTS[0]} testId="most-satisfied-card">
							<SatisfactionRange superlative="most" />
						</Card>
					</GridCol>
					<GridCol span={1}>
						<Card padX={16} height={overviewConfig.ROW_HEIGHTS[0]} testId="least-satisfied-card">
							<SatisfactionRange superlative="least" />
						</Card>
					</GridCol>
					<GridCol span={1}>
						<Card padX={16} height={overviewConfig.ROW_HEIGHTS[0]} testId="enps-score-card">
							<Enps />
						</Card>
					</GridCol>
				</Grid>
			</Row>
			<Row height={overviewConfig.ROW_HEIGHTS[1]}>
				<Divider />
			</Row>
			<Row height={overviewConfig.ROW_HEIGHTS[2]}>
				<Grid gap={2} cols={12} padding={0}>
					<GridCol span={7}>
						<Card height={overviewConfig.ROW_HEIGHTS[2]}>
							<OverallSatisfaction />
						</Card>
					</GridCol>
					<GridCol span={5}>
						<Card height={overviewConfig.ROW_HEIGHTS[2]}>
							<FactorsPolygon />
						</Card>
					</GridCol>
				</Grid>
			</Row>
			<Row height={overviewConfig.ROW_HEIGHTS[3]}>
				<Grid gap={2} cols={3} padding={0}>
					<GridCol span={1}>
						<Card height={overviewConfig.ROW_HEIGHTS[3]} testId="top-cohorts-card">
							<TopCohorts />
						</Card>
					</GridCol>
					<GridCol span={1}>
						<Card height={overviewConfig.ROW_HEIGHTS[3]}>
							<EnpsOverallScatter />
						</Card>
					</GridCol>
					<GridCol span={1}>
						<Card height={overviewConfig.ROW_HEIGHTS[3]}>
							<Participation />
						</Card>
					</GridCol>
				</Grid>
			</Row>
			<Row height={56} />
		</Layout>
	);
};

export default Overview;
